import { Button, customStyled, Flex, variant } from '@mafc/trolly';
import COLORS from 'theme/colors';

export const QuantityUpdate = customStyled(Flex)(({ theme: { radii, space } }) => ({
  alignItems: 'center',
  background: COLORS.WHITE,
  borderRadius: '50%',
  padding: `${space[1]}px`,
  height: '40px',
}));

export const PlusMinusButton = customStyled(Button)((props: any) => ({
  border: 0,
  borderRadius: '50%',
  lineHeight: '1px',
  padding: 0,
  background: props.disabled ? COLORS.MERCURY : COLORS.TRANSPARENT_BLUE_LIGHT,
}));

export const ButtonWrapper = customStyled.span<{ variant: string }>`
  svg g {
    ${() =>
      variant({
        variants: {
          trash: {
            stroke: COLORS.BLUE,
          },
        },
      })}
  }
  svg rect {
    ${() =>
      variant({
        variants: {
          trash: {
            stroke: 'transparent',
            fill: 'transparent',
          },
        },
      })}
  }
`;

export const SelectBox = customStyled.div`
  width: 94px;
  div {
    div {
      /* Overrides height of FDS select box */
      height: 40px;
    }
  }
`;
